module.exports = __webpack_public_path__ + "static/media/(V)-Prata-03.786004d8.jpg";